module.exports = __webpack_public_path__ + "img/shutterstock_527869648_Legs_Only.88e99e55.jpg";